import { render, staticRenderFns } from "./FundraisingCompaniesSection.vue?vue&type=template&id=af28047a&scoped=true"
import script from "./FundraisingCompaniesSection.vue?vue&type=script&lang=js"
export * from "./FundraisingCompaniesSection.vue?vue&type=script&lang=js"
import style0 from "./FundraisingCompaniesSection.vue?vue&type=style&index=0&id=af28047a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af28047a",
  null
  
)

export default component.exports